import { createContext } from 'react';

export type FluxibleExecuteActionType = <Context, Payload, Done extends () => {}>(
  action: (context: Context, vars: Payload, done: Done) => void,
  payload?: Payload
) => Promise<Payload>;

export type FluxibleContextType = {
  executeAction: FluxibleExecuteActionType;
  getStore: {
    <Store extends { new (...args: any[]): any }>(store: Store): InstanceType<Store>;
    <Store extends object>(store: Store): Store;
    <Store>(store: string): Store;
  };
};

const throwError = () => {
  throw new Error(
    'Fluxible context was not initialized! If you see this error in a unit test, ensure you are mocking out the useFluxible() hook.'
  );
};
export const FluxibleContext = createContext<FluxibleContextType>({
  executeAction: throwError,
  getStore: throwError,
});
